// ===============================================
// TRANSLATIONS - الترجمات
// ===============================================
export const translations = {
  ar: {
    selectMonth: 'اختر الشهر',
    selectYear: 'اختر السنة',
    allMonths: 'كل الشهور',
    january: 'يناير',
    february: 'فبراير',
    march: 'مارس',
    april: 'أبريل',
    may: 'مايو',
    june: 'يونيو',
    july: 'يوليو',
    august: 'أغسطس',
    september: 'سبتمبر',
    october: 'أكتوبر',
    november: 'نوفمبر',
    december: 'ديسمبر',
    // Page Header
    pageTitle: 'الراتب والمزايا',
    pageSubtitle: 'تفصيل شامل للراتب مع حسابات النظام الضريبي المصري',
    // Loading States
    loadingSalary: 'جاري تحميل معلومات الراتب...',
    creatingPayroll: 'جاري إنشاء كشف الراتب...',
    // Error Messages
    errorTitle: 'خطأ',
    missingDataError: 'يرجى التأكد من وجود infinityCode و netSalary و insuranceSalary في localStorage',
    noSalaryData: 'لا توجد بيانات راتب في localStorage',
    // Statistics Cards
    grossSalary: 'الراتب الإجمالي',
    totalEarnings: 'إجمالي الدخل قبل الخصومات',
    incomeTax: 'ضريبة الدخل',
    monthlyTaxDeduction: 'خصم الضريبة الشهري',
    socialInsurance: 'التأمين الاجتماعي',
    employeeContribution: 'مساهمة الموظف',
    netSalary: 'صافي الراتب',
    takeHomePay: 'الراتب الصافي المستلم',
    // Deductions Breakdown
    deductionsBreakdown: 'تفصيل الخصومات',
    incomeTaxDesc: 'ضريبة الدخل التصاعدية وفقاً للشرائح الضريبية المصرية',
    socialInsuranceEmployee: 'التأمين الاجتماعي (الموظف)',
    socialInsuranceDesc: 'تغطية المعاش والعجز والوفاة والبطالة',
    martyrsFund: 'صندوق الشهداء',
    martyrsFundDesc: 'مساهمة إلزامية لدعم أسر الشهداء',
    socialInsuranceEmployer: 'التأمين الاجتماعي (صاحب العمل)',
    employerContributionDesc: 'مساهمة صاحب العمل (لا تُخصم من الراتب)',
    penalties: 'الغرامات',
    sickLeave: 'الإجازة المرضية',
    absentDays: 'أيام الغياب',
    // Salary Composition
    salaryComposition: 'تركيبة الراتب',
    basicSalary: 'الراتب الأساسي',
    allowances: 'البدلات',
    ofGrossSalary: 'من الراتب الإجمالي',
    // Salary Summary
    salarySummary: 'ملخص الراتب',
    monthlyGrossSalary: 'الراتب الإجمالي الشهري (جنيه)',
    totalDeductions: 'إجمالي الخصومات (جنيه)',
    netTakeHomePay: 'صافي الراتب المستلم (جنيه)',
    egp: 'جنيه',


    allowancesBreakdown: 'تفصيل البدلات',
    transportationAllowance: 'بدل المواصلات',
    transportationAllowanceDesc: 'بدل المواصلات الشهري',
    variableSalaryAllowance: 'الراتب المتغير',
    variableSalaryDesc: 'المكون المتغير من الراتب',
    overtimeAllowance: 'بدل الساعات الإضافية',
    overtimeAllowanceDesc: 'مكافأة العمل الإضافي',
    bonusAllowance: 'المكافآت',
    bonusAllowanceDesc: 'المكافآت والحوافز',
    expensesAllowance: 'المصروفات',
    expensesAllowanceDesc: 'المصروفات المستردة',
    achievementAllowance: 'بدل الإنجاز',
    achievementAllowanceDesc: 'مكافأة الإنجاز',

    printPayslip: 'طباعة كشف الراتب',
    payslipFor: 'كشف راتب عن',
    employeeInfo: 'بيانات الموظف',
    employeeCode: 'كود الموظف',
    payrollPeriod: 'فترة الراتب',
    to: 'إلى',

    allowanceInstances: 'تفاصيل البدلات',
    deductionInstances: 'تفاصيل الخصومات',
    type: 'النوع',
    description: 'الوصف',
    amount: 'القيمة',
    days: 'أيام',
    hours: 'ساعات',
    total: 'الإجمالي',
    noAllowances: 'لا توجد بدلات',
    noDeductionsRow: 'لا توجد خصومات',

    paymentStatusPaid: 'تم صرف الراتب',
    paymentStatusUnpaid: 'لم يتم صرف الراتب بعد',
  },
  en: {
    selectMonth: 'Select Month',
    selectYear: 'Select Year',
    allMonths: 'All Months',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    // Page Header
    pageTitle: 'Salary & Benefits',
    pageSubtitle: 'Comprehensive salary breakdown with Egyptian tax system calculations',
    // Loading States
    loadingSalary: 'Loading salary information...',
    creatingPayroll: 'Creating payroll...',
    // Error Messages
    errorTitle: 'Error',
    missingDataError: 'Please ensure infinityCode, netSalary, and insuranceSalary are set in localStorage',
    noSalaryData: 'No salary data found in localStorage',
    // Statistics Cards
    grossSalary: 'Gross Salary',
    totalEarnings: 'Total earnings before deductions',
    incomeTax: 'Income Tax',
    monthlyTaxDeduction: 'Monthly tax deduction',
    socialInsurance: 'Social Insurance',
    employeeContribution: 'Employee contribution',
    netSalary: 'Net Salary',
    takeHomePay: 'Take-home pay',
    // Deductions Breakdown
    deductionsBreakdown: 'Deductions Breakdown',
    incomeTaxDesc: 'Progressive income tax based on Egyptian tax brackets',
    socialInsuranceEmployee: 'Social Insurance (Employee)',
    socialInsuranceDesc: 'Pension, disability, death, and unemployment coverage',
    martyrsFund: 'Martyrs Fund',
    martyrsFundDesc: "Mandatory contribution for martyrs' families support",
    socialInsuranceEmployer: 'Social Insurance (Employer)',
    employerContributionDesc: 'Employer contribution (not deducted from salary)',
    penalties: 'Penalties',
    sickLeave: 'Sick Leave',
    absentDays: 'Absent Days',
    // Salary Composition
    salaryComposition: 'Salary Composition',
    basicSalary: 'Basic Salary',
    allowances: 'Allowances',
    ofGrossSalary: 'of gross salary',
    // Salary Summary
    salarySummary: 'Salary Summary',
    monthlyGrossSalary: 'Monthly Gross Salary (EGP)',
    totalDeductions: 'Total Deductions (EGP)',
    netTakeHomePay: 'Net Take-Home Pay (EGP)',
    egp: 'EGP',

    allowancesBreakdown: 'Allowances Breakdown',
    transportationAllowance: 'Transportation Allowance',
    transportationAllowanceDesc: 'Monthly transportation allowance',
    variableSalaryAllowance: 'Variable Salary',
    variableSalaryDesc: 'Variable component of salary',
    overtimeAllowance: 'Overtime',
    overtimeAllowanceDesc: 'Overtime compensation',
    bonusAllowance: 'Bonus',
    bonusAllowanceDesc: 'Performance bonuses and incentives',
    expensesAllowance: 'Expenses',
    expensesAllowanceDesc: 'Reimbursed expenses',
    achievementAllowance: 'Achievement',
    achievementAllowanceDesc: 'Achievement bonus',


    printPayslip: 'Print Payslip',
    payslipFor: 'Payslip For',
    employeeInfo: 'Employee Information',
    employeeCode: 'Employee Code',
    payrollPeriod: 'Payroll Period',
    to: 'to',

    allowanceInstances: 'Allowance Instances',
    deductionInstances: 'Deduction Instances',
    type: 'Type',
    description: 'Description',
    amount: 'Amount',
    days: 'Days',
    hours: 'Hours',
    total: 'Total',
    noAllowances: 'No allowances',
    noDeductionsRow: 'No deductions',

    paymentStatusPaid: 'Salary Paid',
    paymentStatusUnpaid: 'Salary Not Paid Yet',
  }
};


export const getMonthName = (monthNumber, t) => {
    const monthNames = {
      1: t.january, 2: t.february, 3: t.march, 4: t.april,
      5: t.may, 6: t.june, 7: t.july, 8: t.august,
      9: t.september, 10: t.october, 11: t.november, 12: t.december
    };
    return monthNames[monthNumber] || monthNumber;
  };